<template>
    <div class="main main-padding pro-data-details">
        <!--数据信息-->
        <card>
            <!--标题及搜索框-->
            <div class="details-card-header-area">
                <!--tab切换数据-->
                <div class="details-tab-data">
                    <span>学校活跃排名</span>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        placeholder="支持学校名称关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--学校活跃排名-->
                <div class="table-wrapper">
                    <Table :columns="activeUserColumn" :data="activeUserList" @on-sort-change="onSortData"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>
<script>
    import {activeUsers} from "../../service/api.js";

    export default {
        name: "active-user-num",
        data () {
            return {
                keyWord: "",
                page: 1,
                limit: 10,
                total: 0,
                pageCount: 0,//页数
                activeUserColumn: [
                    {
                        title: "学校名称",
                        key: "school_name",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "查看各校数据页面",
                                            //让超链接执行一个js函数，而不是跳转到一个地址
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "14px"
                                        },
                                        on: {
                                            click: () => {
                                                this.gotoSchoolData(params.row, params.index);
                                            }
                                        }
                                    },
                                    params.row.school_name
                                )
                            ]);
                        }
                    },
                    {
                        title: "用户数量",
                        key: "tCount",
                        sortable: 'custom',
                        align: "center",
                        renderHeader: (h, params) => {
                            return h('span', {
                                    style: {
                                        float: "left",
                                        cursor: "pointer",
                                        color: this.tTitle == '' ? '' : "#2d8cf0"
                                    },
                                    on: {
                                        click: () => {
                                            this.handleSortData(params);
                                        }
                                    }
                                },
                                params.column.title + this.tTitle
                            );
                        },
                    },
                    {
                        title: "活跃用户数量",
                        key: "auCount",
                        sortable: 'custom',
                        align: "center",
                        renderHeader: (h, params) => {
                            return h('span', {
                                    style: {
                                        float: "left",
                                        cursor: "pointer",
                                        color: this.auTitle == '' ? '' : "#2d8cf0"
                                    },
                                    on: {
                                        click: () => {
                                            this.handleSortData(params);
                                        }
                                    }
                                },
                                params.column.title + this.auTitle
                            );
                        },
                    },
                    {
                        title: "大屏数量",
                        key: "sCount",
                        sortable: 'custom',
                        align: "center",
                        renderHeader: (h, params) => {
                            return h('span', {
                                    style: {
                                        float: "left",
                                        cursor: "pointer",
                                        color: this.sTitle == '' ? '' : "#2d8cf0"
                                    },
                                    on: {
                                        click: () => {
                                            this.handleSortData(params);
                                        }
                                    }
                                },
                                params.column.title + this.sTitle
                            );
                        },
                    },
                    {
                        title: "活跃大屏数量",
                        key: "asCount",
                        sortable: 'custom',
                        align: "center",
                        renderHeader: (h, params) => {
                            return h('span', {
                                    style: {
                                        float: "left",
                                        cursor: "pointer",
                                        color: this.asTitle == '' ? '' : "#2d8cf0"
                                    },
                                    on: {
                                        click: () => {
                                            this.handleSortData(params);
                                        }
                                    }
                                },
                                params.column.title + this.asTitle
                            );
                        },
                    }
                ],
                activeUserList: [],//数据集合
                tTitle: "",
                auTitle: "",
                sTitle: "",
                asTitle: "",
                sortColumn: 3, //1:大屏数量 2:教师数量 3:活跃教师数量 4:活跃大屏数量
                sortType: 2, //排序类别 1:正序 2:倒叙
                isDesc: false
            }
        },
        methods: {
            /**
             *处理数据
             */
            handleSortData (params) {
                let columnsObj = {};
                let column={};
                this.isDesc = !this.isDesc;
                columnsObj.order = this.isDesc == true ? "desc" : "asc";
                columnsObj.column=column;
                columnsObj.column.key = params.column.key;
                this.onSortData(columnsObj);
            },
            /**
             *点击切换列表样式
             */
            onSortData (columns) {
                if (columns.order == "desc") {
                    this.sortType = 2;
                    if (columns.column.key == "tCount") {
                        this.tTitle = "(降序)";
                        this.auTitle = "";
                        this.sTitle = "";
                        this.asTitle = "";
                        this.sortColumn = 2;
                    } else if (columns.column.key == "auCount") {
                        this.auTitle = "(降序)";
                        this.tTitle = "";
                        this.sTitle = "";
                        this.asTitle = "";
                        this.sortColumn = 3;
                    } else if (columns.column.key == "sCount") {
                        this.sTitle = "(降序)";
                        this.auTitle = "";
                        this.tTitle = "";
                        this.asTitle = "";
                        this.sortColumn = 1;
                    } else if (columns.column.key == "asCount") {
                        this.asTitle = "(降序)";
                        this.auTitle = "";
                        this.tTitle = "";
                        this.sTitle = "";
                        this.sortColumn = 4;
                    }
                } else {
                    this.sortType = 1;
                    if (columns.column.key == "tCount") {
                        this.tTitle = "(升序)";
                        this.auTitle = "";
                        this.sTitle = "";
                        this.asTitle = "";
                        this.sortColumn = 2;
                    } else if (columns.column.key == "auCount") {
                        this.auTitle = "(升序)";
                        this.tTitle = "";
                        this.sTitle = "";
                        this.asTitle = "";
                        this.sortColumn = 3;
                    } else if (columns.column.key == "sCount") {
                        this.sTitle = "(升序)";
                        this.auTitle = "";
                        this.tTitle = "";
                        this.asTitle = "";
                        this.sortColumn = 1;
                    } else if (columns.column.key == "asCount") {
                        this.asTitle = "(升序)";
                        this.auTitle = "";
                        this.tTitle = "";
                        this.sTitle = "";
                        this.sortColumn = 4;
                    }
                }
                this.page = 1;
                this.total = 0;
                this.activeUsers(-1);
            },
            /**
             * 跳转到各校的主页面
             */
            gotoSchoolData (row) {
                let routeData = this.$router.resolve({
                    name: "boardMain",
                    query: {
                        schoolId: row.schoolid,
                        schoolName: row.school_name
                    }
                });
                window.open(routeData.href, "_blank");
            },
            /**
             * 关键字搜索
             */
            handleSearch () {
                this.page = 1;
                this.activeUsers();
            },
            /**
             *获取活跃大屏具体使用详情数据
             */
            async activeUsers (from) {
                let _this = this;
                let params = {
                    sortColumn: _this.sortColumn,
                    sortType: _this.sortType,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await activeUsers(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.activeUserList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                            if (from == 1) {
                                _this.auTitle = "(降序)";
                            }
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 翻页
             */
            handleCurrentChange (val) {
                this.page = val;
                this.activeUsers();
            }
        },
        mounted () {
            //获取班级安装大屏详情数据
            this.activeUsers(1);
        }
    };
</script>
<style lang="scss" scoped>
    @import "../../style/home";
    @import "../../style/dataDetails";
</style>
<style lang="scss">
    .pro-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 37%;
        }

        .ivu-row {
            margin-top: 0 !important;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }

        .ivu-card {
            margin-top: 50px;
        }

        .ivu-table-sort {
            float: right;
            margin-top: 6px;
        }
    }
</style>
